import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CircularProgress } from '@material-ui/core';

/** Components */
import UneditableInput from '../../components/UneditableInput';

/** Services */
import { getWebhookByUniqueId } from '../../services/webhook';

/** Actions */
import { showAlert } from '../../store/ducks/alert';

const WebhookActionsInformation = props => {
  const dispatch = useDispatch();
  const [webhook, setWebhook] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displayWebhooks();
  }, []);

  const uneditable = Object.keys(webhook);

  const displayWebhooks = async () => {
    try {
      setIsLoading(true);
      const uniqueId = props.match.params.uniqueId;

      const { data } = await getWebhookByUniqueId(uniqueId);
      setWebhook(data);

      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', 'Ops! We could not load. 😔'));
      console.log(error);
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <section className="update-section">
        <div className="update-section-top">
          <h3>Webhook Information</h3>
        </div>
        <form className="update-form">
          <div className="form-fields">
            <UneditableInput data={webhook} labels={uneditable} />
          </div>
        </form>
      </section>
    </>
  );
};

export default WebhookActionsInformation;
